if (!customElements.get('megamenu-slider')) {
  class MegamenuSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 1.43,
      spaceBetween: 16,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 12,
        },
      },
    };
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('megamenu-slider', MegamenuSlider);
}
